const ENTRADA = 1
const SAIDA = 2

const DESCRICAO_TIPOS = {
  [ENTRADA]: 'Entrada',
  [SAIDA]: 'Saída',
}

module.exports = {
  ENTRADA,
  SAIDA,

  DESCRICAO_TIPOS,
}
